export const updateGTM = (location: Location) => {
	// @ts-ignore
	dataLayer.push({
		event: 'notifgtm',
		location: location.pathname
	})
}
